<template>
  <p>Dashboard</p>
</template>

<script>
export default {

}
</script>

<style>

</style>